// set
const html = document.documentElement.style,
      body = document.body.style,
      breakpoint = window.matchMedia('(min-width: 768px)')


// vh
function setHeight(){
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}
setHeight()
window.addEventListener('resize', setHeight)


// navi sticky
const sticky = document.querySelector('.l-header__navigation'),
      fposi = 300
let iposi = 0

window.addEventListener('scroll', function(){
  let wposi = window.scrollY
  if(fposi <= wposi && iposi <= wposi){ sticky.classList.add('is-disable') }
  else{ sticky.classList.remove('is-disable') }
  iposi = wposi
})


// navi menu
const menuIcon = document.querySelector('.l-header__toggle'),
      menuList = document.querySelector('.l-header__navigation'),
      menuItem = document.querySelectorAll('.l-header__navigation li'),
      menuOver = document.querySelector('.l-header__navigation-overlay')

function classAdd(){
  menuIcon.classList.add('is-active')
  menuList.classList.add('is-active')
  html.overflow = 'hidden'
  body.overflow = 'hidden'
  let i = 1
  Array.prototype.forEach.call(menuItem, element => {
    setTimeout(() => {element.classList.add('is-anima')}, 120 * i)
    i++
  })
}
function classRemove(){
  menuIcon.classList.remove('is-active')
  menuList.classList.remove('is-active')
  html.overflow = ''
  body.overflow = ''
  Array.prototype.forEach.call(menuItem, element => {
    element.classList.remove('is-anima')
  })
}
menuIcon.addEventListener('click', function(){
  if(this.classList.contains('is-active')){ classRemove() }
  else{ classAdd() }
})
menuOver.addEventListener('click', function(){
  classRemove()
})


// swiper
new Swiper('.p-top-intro__swiper', {
  centeredSlides: true,
  effect: 'fade',
  grabCursor: true,
  slidesPerView: 1,
  speed: 600,
  autoplay: {
    delay: 3600,
    disableOnInteraction: false
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
})